module.exports = __webpack_public_path__ + "img/Facebook-Mosiac.5346039c.png";